import Lottie, { type LottieRefCurrentProps } from "lottie-react";
import { useEffect, useRef } from "react";

type Props = {
  animationData: unknown;
  className?: string;
  preserveAspectRatio?: string;
};

/** Lottie that only plays while on screen and stays still for reduced-motion users. */
export const ViewportLottie = ({ animationData, className, preserveAspectRatio }: Props) => {
  const wrapRef = useRef<HTMLDivElement>(null);
  const lottieRef = useRef<LottieRefCurrentProps>(null);

  useEffect(() => {
    const el = wrapRef.current;
    if (!el) return;
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduced) {
      lottieRef.current?.goToAndStop(0, true);
      return;
    }
    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) lottieRef.current?.play();
        else lottieRef.current?.pause();
      },
      { threshold: 0.1 },
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);

  return (
    <div ref={wrapRef} className={className}>
      <Lottie
        lottieRef={lottieRef}
        animationData={animationData}
        loop
        autoplay={false}
        className="w-full h-full"
        rendererSettings={{ preserveAspectRatio, progressiveLoad: true }}
      />
    </div>
  );
};
